import {Serializer} from '~/app/core/common/serializers/serializer';
import {OrderSchedule} from '~/app/core/common/models/orderSchedule';

export class OrderScheduleSerializer implements Serializer {
    fromJson(json: any): OrderSchedule {
        const orderSchedule = new OrderSchedule();
        orderSchedule.trackingId = json.trackingId;
        orderSchedule.status = json.status;
        orderSchedule.callDate = json.callDate;
        orderSchedule.deliveryDate = json.deliveryDate;
        orderSchedule.orderNo = json.orderNo;
        orderSchedule.release = json.release;
        orderSchedule.callDateFormatted = json.callDateFormatted;
        orderSchedule.deliveryDateFormatted = json.deliveryDateFormatted != null ? json.deliveryDateFormatted : '';
        return orderSchedule;
    }

    toJson(resource: OrderSchedule) {
        return JSON.stringify(resource);
    }

}
